import i18n from "../locales/i18n";
import { LOCALES } from "../locales/languages";
// Librairies
import { enUS, es, fr, nlBE, zhTW } from 'date-fns/locale';

export default class LanguagesUtil {
    static clearLists() {
        const itemsToRemove = [
            'actions', 'projections', 'vigors', 'furnitureTypes', 'spaceFunctions', 'coverTypes', 'spaceTypes', 'ontogenicStages', 'patrimonialCoefficients', 'conditions',
            'actions', 'dominantCompositions', 'essences', 'formulas', 'spaceTypeCategories', 'interactions', 'microHabitats', 'rootSymptoms', 'collarSymptoms', 'trunkSymptoms', 'branchSymptoms',
            'leafSymptoms', 'pathogens', 'pests', 'epiphytes', 'risks', 'tippingRisks', 'organCalibers', 'targets', 'plantationCoefficients', 'treePorts',
            'plantationTypes', 'situationCoefficients', 'healthReviews', 'archiStages', 'archiStates'
        ];

        for (const item in localStorage)
            if (itemsToRemove.includes(item))
                localStorage.removeItem(item);
    }

    static getCultureFlagName(culture) {
        if (culture.toLowerCase().includes('fr')) return 'fr';
        if (culture.toLowerCase().includes('nl')) return 'nl';
        if (culture.toLowerCase().includes('us')) return 'gb';
        if (culture.toLowerCase().includes('es')) return 'es';
        if (culture.toLowerCase().includes('zh')) return 'tw';
        return '';
    }

    //? Langue du compte, sinon langue détectée par i18next (toujours l'une des langues de l'application).
    //? La synchronisation d'i18next avec la langue du compte se fait dans App.js, avec rechargement
    static getUserCulture(userInfos) {
        return userInfos?.language?.culture || i18n.language;
    }

    //? Locale BCP 47 à passer à Intl et aux toLocaleString (zh-CHT => zh-TW)
    static getLocale(culture = i18n.language) {
        return LOCALES[culture] || LOCALES['fr-BE'];
    }

    static getDateFnsLocale(culture = i18n.language) {
        return { 'nl-BE': nlBE, 'en-US': enUS, 'es-ES': es, 'zh-CHT': zhTW }[culture] || fr;
    }

    //? Locale moment du calendrier (semantic-ui-calendar-react) ; les fichiers de locale sont importés par DatePicker
    static getMomentLocale(culture = i18n.language) {
        return { 'nl-BE': 'nl', 'en-US': 'en', 'es-ES': 'es', 'zh-CHT': 'zh-tw' }[culture] || 'fr';
    }
}